import Api from './api';

const inlandCompaniesListRequest = () => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().get('/api/companies', {
        headers: { Authorization: 'Bearer ' + access_token } ,
    })
}

const createInlandCompanyRequest = (data) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().post('/api/companies/', data, { headers: { Authorization: 'Bearer ' + access_token } })
}

const updateInlandCompanyRequest = (data) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().put('/api/companies/' + data.id, data, { headers: { Authorization: 'Bearer ' + access_token } })
}


const deleteInlandCompanyRequest = (id) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().delete('/api/companies/' + id, { headers:
        {
            Authorization: 'Bearer ' + access_token,
            'Content-Type': 'application/x-www-form-urlencoded'
        }

    })
}


export default {
    inlandCompaniesListRequest,
    createInlandCompanyRequest,
    deleteInlandCompanyRequest,
    updateInlandCompanyRequest
}



// WEBPACK FOOTER //
// ./src/api/apiInlandCompanies.js